import { configureStore } from "@reduxjs/toolkit";
import themeSlice from "./theme-slice";
import sidebarSlice from "./sidebar-slice";
import commandsSlice from "./commands-slice";

const store = configureStore({
  reducer: {
    theme: themeSlice.reducer,
    sidebar: sidebarSlice.reducer,
    commands: commandsSlice.reducer,
  },
});

export default store;
